import { requestWithToken } from '../../utilities/request';
const path = '/api/private/fields';

/**
 * 実績集計一覧取得API
 * @param {string} fieldId: 現場ID
 * @param {object} params
 * @returns {Promise<any>}
 * */
const fetchFieldTreeResultList = async (fieldId, params) => {
  return await requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/field_tree_results/list`),
    params,
  });
};

export const FieldTreeResultApi = {
  fetchFieldTreeResultList,
};

export default FieldTreeResultApi;



// WEBPACK FOOTER //
// ./src/services/fieldTreeResult/FieldTreeResultApi.js